import { LAYOUT_LIST, LAYOUT_PG_SIDE_BY_SIDE } from '@wix/communities-blog-client-common';
import { getIsMobile } from '../../../common/store/basic-params/basic-params-selectors';
import { type AppState } from '../../../common/types';

export const getMyPostsLayoutType = (state: AppState) =>
  getIsMobile(state) ? LAYOUT_LIST : LAYOUT_PG_SIDE_BY_SIDE;
